module.exports = __webpack_public_path__ + "static/media/project-panorama.2e0c0464.jpg";